import { render, staticRenderFns } from "./communitymerchant.vue?vue&type=template&id=440979f3&scoped=true&"
import script from "./communitymerchant.vue?vue&type=script&lang=js&"
export * from "./communitymerchant.vue?vue&type=script&lang=js&"
import style0 from "./communitymerchant.vue?vue&type=style&index=0&id=440979f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440979f3",
  null
  
)

export default component.exports